import React from 'react';
import { useTranslation } from 'react-i18next';
import { useOrganization } from '../shared/branding/OrganizationContext';
import { isLikelyPlatformTenantHost } from '../shared/branding/tenantHost';
import TenantLanding from '../apps/public/TenantLanding';
import MarketingLanding from './landingMarketing';

/**
 * Root `/` router: tenant hosts → white-label welcome; platform → marketing.
 * Never show Coursolo marketing on a platform subdomain or verified custom domain.
 */
export default function Landing() {
    const { t } = useTranslation();
    const { organization, branding, loading, error } = useOrganization();
    const host = typeof window !== 'undefined' ? window.location.hostname : '';

    const tenantBySubdomain = isLikelyPlatformTenantHost(host);
    const tenantByApi = Boolean(organization?.tenant);
    const isTenantSurface = tenantBySubdomain || tenantByApi;

    if (loading && isTenantSurface) {
        return <div className="min-h-screen bg-slate-50 dark:bg-slate-950" aria-busy="true" />;
    }

    if (isTenantSurface) {
        if (organization?.id || branding || organization?.slug) {
            return <TenantLanding />;
        }
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950 px-4">
                <div className="max-w-md text-center">
                    <h1 className="text-xl font-semibold text-slate-900 dark:text-white">
                        {t('public.tenantLanding.unavailableTitle', 'Workspace unavailable')}
                    </h1>
                    <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">
                        {error
                            || t('public.tenantLanding.unavailableBody', 'This organization workspace could not be loaded. Check the URL or try again later.')}
                    </p>
                </div>
            </div>
        );
    }

    if (loading && !organization) {
        return <div className="min-h-screen bg-slate-50" aria-busy="true" />;
    }

    return <MarketingLanding />;
}
